import { render, staticRenderFns } from "./ScheduleStatistice.vue?vue&type=template&id=20816dad"
import script from "./ScheduleStatistice.vue?vue&type=script&lang=js"
export * from "./ScheduleStatistice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports